// Neues Passwort mit Wiederholung und Hinweisen zur Richtlinie (DQ-SEC-040: mind. 12 Zeichen, keine häufigen Passwörter;
// die Liste prüft der Server).
import { useTranslation } from 'react-i18next';
import { Field } from '../../components/ui';

export const MIN_PASSWORD = 12;
export const passwordOk = (pw: string, repeat: string) => pw.length >= MIN_PASSWORD && pw === repeat;

/** Grobe Stärke 0–4 (Länge und Zeichenarten), nur als Orientierung. */
export function strength(pw: string): number {
  if (pw.length < MIN_PASSWORD) return 0;
  const kinds = [/[a-z]/, /[A-Z]/, /[0-9]/, /[^a-zA-Z0-9]/].filter((r) => r.test(pw)).length;
  return Math.min(4, 1 + (pw.length >= 16 ? 1 : 0) + (kinds >= 3 ? 1 : 0) + (pw.length >= 20 || kinds === 4 ? 1 : 0));
}

export function PasswordFields({ value, repeat, onChange, onRepeat, label }: { value: string; repeat: string; onChange: (v: string) => void; onRepeat: (v: string) => void; label?: string }) {
  const { t } = useTranslation();
  const s = strength(value);
  const mismatch = repeat.length > 0 && repeat !== value;
  return (
    <>
      <Field label={label ?? t('account.password.new')} hint={t('account.password.rules')}>
        <input type="password" autoComplete="new-password" value={value} onChange={(e) => onChange(e.target.value)} />
      </Field>
      {value && (
        <div className="pw-meter" data-level={s} aria-live="polite">
          <span /><span /><span /><span />
          <b className="small">{value.length < MIN_PASSWORD ? t('account.password.tooShort', { n: MIN_PASSWORD - value.length }) : t(`account.password.strength.${s}`)}</b>
        </div>
      )}
      <Field label={t('account.password.repeat')} error={mismatch ? t('account.password.mismatch') : undefined}>
        <input type="password" autoComplete="new-password" value={repeat} onChange={(e) => onRepeat(e.target.value)} />
      </Field>
    </>
  );
}
